import { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api, type ListResult } from '@/lib/api-client.js';
import { queryKeys } from '@/lib/query-keys.js';
import { useAuth } from '@/features/auth/auth-context.js';
import { Sidebar } from './Sidebar.js';
import { Topbar } from './Topbar.js';

const COLLAPSE_KEY = 'geoic:sidebar-collapsed';

/**
 * Admin karkasi — MAKETDAN (`D1`): chapda to'q ko'k menyu, tepada
 * qidiruv va foydalanuvchi bloki.
 *
 * Menyu holati `localStorage` da — foydalanuvchi har kirganda uni qayta
 * yig'ib o'tirmasin. Bu maxfiy ma'lumot emas, shuning uchun brauzerda
 * saqlanishi xavfsiz.
 */
export function AppShell() {
  const { user, logout, can } = useAuth();
  const [collapsed, setCollapsed] = useState(() => readCollapsed());

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSE_KEY, String(collapsed));
    } catch {
      // Shaxsiy rejimda `localStorage` yozishga ruxsat bermasligi mumkin —
      // bu holat interfeysni buzmasligi kerak.
    }
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsed((value) => !value), []);

  /*
    Maketda «Arizalar» yonida ochilmagan arizalar soni turadi. Faqat
    SON kerak — `limit: 1` bilan `meta.total` olinadi (boshqaruv
    panelidagi ko'rsatkichlar bilan bir xil usul va bir xil kesh
    kaliti, ya'ni ikkinchi so'rov ketmaydi).
  */
  const canSeeRequests = can('superadmin', 'admin', 'sales');
  const newRequests = { status: 'new', page: 1, limit: 1 };
  const { data: fresh } = useQuery({
    queryKey: queryKeys.requests.list(newRequests),
    queryFn: () => api.get<ListResult<unknown>>('/requests', newRequests),
    enabled: canSeeRequests,
  });

  if (!user) return null;

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar
        role={user.role}
        user={user}
        collapsed={collapsed}
        onToggle={toggle}
        badges={{ '/requests': fresh?.meta.total ?? 0 }}
      />

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar user={user} onLogout={() => void logout()} siteUrl={SITE_URL} />

        <main className="flex-1 overflow-y-auto bg-n-50 p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

/**
 * «Saytni ko'rish» manzili.
 *
 * Muhit o'zgaruvchisidan olinadi; berilmasa tugma ko'rsatilmaydi —
 * ishlamaydigan havola bo'sh oynani ochib qo'yardi.
 */
const SITE_URL = import.meta.env.VITE_SITE_URL as string | undefined;

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(COLLAPSE_KEY) === 'true';
  } catch {
    return false;
  }
}
